import "core-js/modules/es.array.concat.js";
export default (function (_ref) {
  var request = _ref.request;
  return {
    labAdd: function labAdd(data) {
      return request({
        url: '/org/lab',
        method: 'post',
        data: data
      });
    },
    labModify: function labModify(data) {
      return request({
        url: "/org/lab/".concat(data.id),
        method: 'put',
        data: data
      });
    },
    labAccess: function labAccess(handleId, data) {
      return request({
        url: "/org/lab/".concat(handleId, "/access"),
        method: 'put',
        data: data
      });
    },
    labDel: function labDel(id) {
      return request({
        url: "/org/lab/".concat(id),
        method: 'delete'
      });
    },
    labQuery: function labQuery(data) {
      return request({
        url: '/org/lab',
        method: 'get',
        params: data
      });
    },
    labQueryRestricted: function labQueryRestricted(data) {
      return request({
        url: '/org/lab/queryRestricted',
        method: 'get',
        params: data
      });
    },
    labQueryReport: function labQueryReport() {
      return request({
        url: '/org/lab/report',
        method: 'get'
      });
    },
    labDetail: function labDetail(id) {
      return request({
        url: "/org/lab/".concat(id),
        method: 'get'
      });
    },
    labWeather: function labWeather(districtId) {
      return request({
        url: "/common/priceTrend/weather/".concat(districtId),
        method: 'post'
      });
    },
    labBindWeather: function labBindWeather(id, deviceId) {
      return request({
        url: "/org/lab/".concat(id, "/bindWeatherDevice/").concat(deviceId),
        method: 'POST'
      });
    },
    labUnbindWeather: function labUnbindWeather(id) {
      return request({
        url: "/org/lab/".concat(id, "/unbindWeatherDevice"),
        method: 'DELETE'
      });
    }
  };
});